const labTwoFormData = {
  id: 2,
  photoURLDigging: "",
  photoURLSelfie: "",
  photoURLObstacle: "",
  photoURLNorth: "",
  photoURLSouth: "",
  photoURLEast: "",
  photoURLWest: "",
  discussionAnswers: [
    { answer: "" },
    { answer: "" },
    { answer: "" },
    { answer: "" },
    { answer: "" },
    { answer: "" },
    { answer: "" },
    { answer: "" }
  ],
  discussionClimateAnswers: [{ answer: "" }, { answer: "" }],
  discussionOrganismAnswers: [{ answer: "" }, { answer: "" }],
  discussionTopologyAnswers: [{ answer: "" }, { answer: "" }],
  discussionParentMaterialAnswers: [{ answer: "" }, { answer: "" }],
  discussionTimeAnswers: [{ answer: "" }, { answer: "" }],
  discussionHumanActivityAnswers: [{ answer: "" }, { answer: "" }],
  discussionSummaryAnswers: [{ answer: "" }]
};

export default labTwoFormData;
